import React from 'react';
import styles from './Checkbox.module.css';

const Checkbox = ({
    checked = false,
    onChange,
    label,
    disabled = false,
    indeterminate = false,
    name,
    value,
    className = '',
    id,
}) => {
    const handleChange = (e) => {
        if (!disabled && onChange) {
            onChange(e.target.checked);
        }
    };

    return (
        <label className={`${styles.checkboxContainer} ${className} ${disabled ? styles.disabled : ''}`}>
            <input
                type="checkbox"
                className={styles.checkbox}
                checked={checked}
                onChange={handleChange}
                disabled={disabled}
                name={name}
                value={value}
                id={id}
                ref={input => {
                    if (input) {
                        input.indeterminate = indeterminate;
                    }
                }}
            />
            <span className={styles.customCheckbox}>
                {checked && (
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 6L5 9L10 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                )}
                {indeterminate && !checked && (
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 6H10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                )}
            </span>
            {label && <span className={styles.label}>{label}</span>}
        </label>
    );
};

export default Checkbox;
